import React, { useState } from "react";
import { scaleBars } from "../lib/reports";

// Minimal, dependency-free charts in the design tokens: one series, navy
// marks, recessive baseline, values in text ink. Each chart has an
// aria-label and the same numbers are always in a table or list nearby.

// Vertical columns over time (funnel buckets).
// data: [{key, label, value, display, title, muted}]
export function ColumnChart({ data, ariaLabel, height = 140 }) {
    const [hover, setHover] = useState(null);
    const heights = scaleBars(data.map((d) => d.value));
    const maxIdx = heights.indexOf(Math.max(...heights));
    const tickEvery = data.length > 16 ? 4 : data.length > 8 ? 2 : 1;
    return (
        <div className="hz-colchart" role="img" aria-label={ariaLabel}>
            <div className="hz-colchart-plot" style={{ height }}>
                {data.map((d, i) => {
                    const showValue = hover === i || (hover === null && i === maxIdx && d.value > 0);
                    return (
                        <div
                            key={d.key || d.label}
                            className={"hz-colchart-col" + (hover === i ? " hover" : "")}
                            onMouseEnter={() => setHover(i)}
                            onMouseLeave={() => setHover(null)}
                            title={d.title}
                        >
                            {showValue && <span className="hz-colchart-value">{d.display}</span>}
                            <span className={"hz-colchart-bar" + (d.muted ? " muted" : "")} style={{ height: `${Math.max(heights[i], d.value > 0 ? 2 : 0)}%` }}></span>
                        </div>
                    );
                })}
            </div>
            <div className="hz-colchart-axis">
                {data.map((d, i) => (
                    <span key={d.key || d.label} className="hz-colchart-tick">
                        {i % tickEvery === 0 || hover === i ? d.label : ""}
                    </span>
                ))}
            </div>
        </div>
    );
}

// Horizontal bars with the value on the right (wins by source, stage days).
// rows: [{key, label, value, display, sub}]
export function BarList({ rows, ariaLabel, labelWidth = 120 }) {
    const widths = scaleBars(rows.map((r) => r.value));
    return (
        <div className="hz-barlist" role="img" aria-label={ariaLabel}>
            {rows.map((r, i) => (
                <div key={r.key || r.label} className="hz-barlist-row" style={{ gridTemplateColumns: `${labelWidth}px 1fr auto` }}>
                    <span className="hz-ellipsis">{r.label}</span>
                    <span className="hz-bar hz-bar-wide hz-barlist-track">
                        <span className="hz-fill-primary" style={{ width: `${widths[i]}%` }}></span>
                    </span>
                    <span className="hz-barlist-value">
                        {r.display}
                        {r.sub && <span className="hz-muted hz-small"> {r.sub}</span>}
                    </span>
                </div>
            ))}
        </div>
    );
}

// Progress against a target with a "time gone" marker.
export function TargetBar({ reached, time, label }) {
    return (
        <div className="hz-target" role="img" aria-label={label}>
            <div className="hz-target-track">
                <span className="hz-target-fill" style={{ width: `${reached}%` }}></span>
                <span className="hz-target-time" style={{ left: `${time}%` }} title="Share of the quarter gone"></span>
            </div>
        </div>
    );
}
